<template>
    <div>
    
        <b-navbar toggleable="lg" type="dark" class="menuheader" fixed="top">

         <b-button v-if="isMobile" class="menu-icon" @click="toggleMenuLeft">
            <b-icon icon="list" variant="light"></b-icon>
        </b-button>
        
            <b-navbar-brand>
                <div class="logos-navbar-container">
                    <img class="logoheader" @click="refh()" src="../../public/img/logo.png">
                    <img class="logoheader-sura" @click="refh()" src="../../public/img/logogris.webp">
                </div>
            </b-navbar-brand>
   
                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    
                <b-collapse id="nav-collapse" is-nav>

                    <!-- Right aligned nav items -->

                    <b-navbar-nav class="ml-auto">

                        <b-nav-form>

                            <!-- <b-input-group>

                            
                                <b-form-input class=" tmmh emaillll "  :placeholder="placeholderd"></b-form-input>
                                <b-input-group-append>
                                    <b-button class="lupabtno" size="sm" text="Button" variant="light"> <b-icon class="iconolupa" icon="search"></b-icon></b-button>
                                </b-input-group-append>
                            </b-input-group>
                         -->
                        </b-nav-form>
                        <b-dropdown menu-class="w-500" size="lg" class="bntt"  variant="link" toggle-class="text-decoration-none" no-caret>
                        <!-- <template #button-content>
                            <b-button class="botonnotiw">
                            
                                <b-icon class="" icon="bell" />
                            
                                <b-badge class="bag" variant="light">4</b-badge>
                            
                            </b-button>
                        </template> -->
                                <b-dropdown-item class="textonotifi" >
                                <span class="texto"><b>Maria</b> ha agregado una<br> <b>nueva tarea</b></span><br>
                                    <span class="minutos">Hace 45 minutos</span>
                                    <div class="articulacion">Articulación</div>
                                </b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item class="textonotifi" >
                                <span class="texto"><b>Maria</b> ha agregado una<br> <b>nueva tarea</b></span><br>
                                    <span class="minutos">Hace 45 minutos</span>
                                    <div class="articulacion">Articulación</div>
                                </b-dropdown-item >
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item class="textonotifi" disabled >
                                <span class="texto"><b>Maria</b> ha agregado una<br> <b>nueva tarea</b></span><br>
                                    <span class="minutos">Hace 45 minutos</span>
                                    <div class="articulacion">Articulación</div>
                                </b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item style="text-align: center;" >
                                <b> Ver más</b>
                                </b-dropdown-item>
                            </b-dropdown>
                        
                        
                        
                </b-navbar-nav>
                <b-navbar-brand>
                    
                </b-navbar-brand>
                
                </b-collapse>

                <b-dropdown class="m-2 botonnotii bnn" no-caret>
                    <template #button-content>
                        <b-row class="anchonamen">
                        
                            <b-col cols="3">
                        
                                <b-avatar class="mr-3 iconoavatar"></b-avatar>
                        
                            </b-col>
                        
                            <b-col cols="7" class="nombreboton">
                        
                                <p class="mr-auto pril nombreperfil"><b>{{nombre}} </b></p>
                        
                                <p class="mr-auto pril">{{usuario}}</p>
                        
                            </b-col>
                        
                            <b-col cols="2">
                        
                                <b-icon class="downn" icon="chevron-down"></b-icon>
                        
                            </b-col>
                        
                        </b-row>
                    </template>
                    
                
                    <b-dropdown-item href="#"  @click="cambio(usuario)"><b-icon  icon="unlock" ></b-icon> Cambiar contraseña</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item href="#"  @click="informacion()"><b-icon  icon="person-fill" ></b-icon> Información personal</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="logOut()"><b-icon  icon="box-arrow-right" ></b-icon> Cerrar sesión</b-dropdown-item>
                </b-dropdown>
         
    
            
        </b-navbar>
       
            <b-modal
              centered
              hide-footer
              no-close-on-backdrop
              no-close-on-esc
              hide-header
              v-model="bloqueo"
              title="Bloqueo por intentos"
            >
            <ModalAcep :mensaje="mensaje" :ruta="ruta" :boton="boton" />

            </b-modal>
        </div>
                  
   
</template>
<script>
import Vue from 'vue'
import IdleVue from 'idle-vue'
import ModalAcep from "../components/ModalAcep.vue";
import { RepositoryFactory } from "../repositories/RepositoryFactory";
const config = RepositoryFactory.get("config");

const eventsHub = new Vue()
Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    idleTime: 3600000
})
export default {
    name: "MenuHeader",
    components: {
        ModalAcep,
    },

    props: [
        "logo",
    ],
    data() {
        return {
             isMobile: false,
            time:10000,
            mensaje: "Has superado el tiempo de inactividad. Debes iniciar sesión nuevamente.",
            ruta: "/login",
            boton: "Aceptar",
            nombre:"",
            usuario:"",
            messageStr: 'Hello0',
            bloqueo:false,
            imagenSeleccionada: {
                id: 0,
                name: 'data:image/png;base64,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',
            },
            placeholderd: "Encuentra solicitudes, reportes y más…",
            url: [{
                    id: 0,
                    name: 'data:image/png;base64,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',
                }, {
                    id: 1,
                    name: 'data:image/png;base64,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',
                },
                {
                    id: 2,
                    name: 'https://fundacionpostobon.com/wp-content/uploads/2018/03/logo-comfama-01.png',
                }
            ]
        }
    },
    onIdle() {
        this.bloqueo=true;
        localStorage.clear();
      
    },
    onActive() {
        this.messageStr = 'Hello1'
    },
    async created() {
          this.checkIfMobile();
    window.addEventListener('resize', this.checkIfMobile);
        const token = localStorage.getItem('userToken');
        const response = await config.datosPersonales({
                "token":token,
            });
        localStorage.setItem("user", JSON.stringify(response[0]));  
            this.nombre= response[0].primer_nombre + " "+response[0].primer_apellido;
            this.usuario=response[0].nombre_usuario;
    },
    methods: {
        checkIfMobile() {
      this.isMobile = window.innerWidth <= 768; // Define el tamaño para considerar una pantalla como "móvil"
    },
        abrirModal() {
            this.modalAbierto = true;
        },

        cerrarModal() {
            this.modalAbierto = false;
        },
        cambio(dato) {
            // this.$router.push({ params: { path: '/cambio-contrasena-inicio', myParam: dato }});
            this.$router.push({ name: 'cambio-contrasena-inicio', params: { myParam: dato } });
        },
        informacion() {
            this.$router.push("/informacion-personal");
        },
        logOut() {
            localStorage.clear();
            this.$router.go("/login");
        },
        seleccion(imagen) {
            this.imagenSeleccionada = imagen;
        },
        refh() {
            this.$router.push("/inicio");
        },
        toggleMenuLeft() {
            this.$root.$emit('toggleMobileMenu');
        }
    },

}
</script>
<style>

.hrmenu {
    position: absolute;
    color: #bec2e3 !important;
    width: 198px;
    left: -2%;
}

.w-500 {
    margin-top: 82% !important;
    margin-left: -150% !important;
}

.w-400 {
    width: 200px;
    text-align: center !important;
    margin-left: -24% !important;
}
.nombreperfil{
    text-transform: capitalize !important;
}
.textonotifi {
    font-family: var(--font-family-poppins);
}

* {
    font-family: var(--font-family-poppins);
}

.iconolupa {
    zoom: 1.2;
}

.lupabtno {
    border-top-right-radius: 8px !important;
    border-bottom-right-radius: 8px !important;
    border-bottom-left-radius: 0 !important;
    border-top-left-radius: 0 !important;
    height: 50px;
}

.iconoolupa {
    color: var(--blue-violet);
}

.todos {
    color: var(--blue-violet) !important;
    font-family: var(--font-family-poppins);
    font-size: 14px !important;
    font-weight: 600 !important;
}

.todos:hover {
    color: white !important;
    background: var(--blue-violet) !important;
}

.w-500 {
    width: 320px;
}

.texto {
    font-size: 12px;
}

.articulacion {
    background: var(--blue-violet-2);
    color: white;
    border-radius: 8px;
    font-size: 12px;
    padding: 1%;
    width: 28%;
    float: right;
    text-align: center;
    margin-top: -10%;
}

.minutos {
    font-size: 12px;
    color: grey;
}

.bnt {
    --background: white !important;
    width: 10% !important;
    right: 1%;
    --bs-btn-bg: white !important;
    ;
    --bs-btn-border-color: white !important;
    font-family: var(--font-family-poppins);
}

.bnn {
    width: 18% !important;
    right: 1%;
    height: 50px;
    font-family: var(--font-family-poppins);
}

.bntt {
    margin-left: 2%;
    font-family: var(--font-family-poppins);
    margin-top: -2%;
}

.imagensele {
    width: 151%;
}

.imglogo {
    width: 66%;
}

.dropdown-menu {
    --bs-dropdown-link-active-bg: var(--blue-violet) !important;
    --bs-dropdown-link-color: var(--blue-violet) !important;
    font-weight: 600 !important;
    border-radius: 9px !important;
    --bs-dropdown-link-hover-color: var(--blue-violet) !important;
    /* --bs-dropdown-link-hover-bg: var(--blue-violet) !important; */
}

.dropdown-menu :hover {
  /*  background-color: var(--blue-violet) !important;*/
   /* color: white !important;*/
}

.iconoavatar {
    width: 100% !important;
}

.downnnm {
    width: 12px !important;
    margin-top: 7%;
    color: grey;
    margin-left: 13%;
    position: absolute;
}

.downn {
    width: 12px !important;
    margin-top: 42%;
}

.dropdown-menu.show {
    margin-top: 55px;
    margin-left: 0%;
    font-size: 14px;
    /* width: 100%; */
}

.nombreboton {
    text-align: left;
}

.pril {
    line-height: 0px;
    margin-top: 11%;
    font-size: 10px;
    margin-left: -10%;
    font-weight: 800;
}

.bag {
    background: red;
    position: absolute !important;
    top: 11% !important;
    font-weight: 500 !important;
    border-radius: 46px !important;
    right: 13%;
}

.botonnoti {
    background-color: var(--blue-violet-2) !important;
    border-radius: 10px !important;
    border-color: var(--blue-violet-2) !important;
}

.botonnotiw {
    background-color: var(--blue-violet-2) !important;
    border-radius: 15px !important;
    border-color: var(--blue-violet-2) !important;
    height: 50px !important;
}

.botonnotiw:hover {
    background: white !important;
    background-color: white !important;
    color: red;
}

.botonnotiee {
    background-color: white !important;
    border-radius: 10px !important;
    border-color: white !important;
}

.btn-secondary {
    --bs-btn-color: #fff;
    --bs-btn-bg: var(--blue-violet-2) !important;
    ;
    --bs-btn-border-color: var(--blue-violet-2) !important;
}

.btn-light {
    font-size: 12px !important;
    font-weight: 600 !important;
    --bs-btn-color: var(--blue-violet) !important;
    --bs-btn-bg: white !important;
    ;
    --bs-btn-border-color: white !important;
}

.btn-secondary:hover {
    background: var(--hover) !important;
    --bs-btn-border-color: var(--blue-violet-2) !important;
}

.botonnoti:hover {
    background: var(--hover) !important;
}

.menuheader {
    align-items: center;
    height: 73px;
    background-color: var(--blue-violet);
}

.tmmh {
    /* height: 52px; */
    margin-left: 6%;
    font-size: 12px !important;
    width: 485px !important;
    margin-bottom: 0%;
    border-top-left-radius:15px;
    border-bottom-left-radius: 15px;
    /* margin-top: 1%; */
}

.ml-auto {
    width: 50%;
    font-family: var(--font-family-poppins);
}

.logos-navbar-container {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.logoheader {
    width: 100%;
    max-width: 140px;
    cursor: pointer;
}

.logoheader-sura {
    width: 100%;
    max-width: 140px;
    cursor: pointer;
}

.navbar-brand {
    width: 18% !important;
}

.lupa {
    flex-wrap: unset !important;
    margin-top: 13%;
    margin-bottom: 9%;
    margin-right: -16%;
    height: 88.8%;
}

.input-group {
    flex-wrap: unset !important;
}

@media (max-width: 1922px) {
   
}
@media (max-width: 1540px) {
    
}
@media (max-width: 1370px) {
    .anchonamen{
        width: 230px !important;
    }
}
@media (max-width: 1280px){
    .anchonamen{
        width: 230px !important;
    }
}
@media (max-width: 1070px){
    .anchonamen{
        width: 228px !important;
    }
    .bnn {
        right: 6% !important;
    }
    .collapsed, .bntt , .form-inline{
        display: none !important;
    }
    .menu {
    height: 103vh !important;
    width: 8.3% !important;
}
.text-muted{
    display: none !important;
}
.sidebar-1 {
    left: 8.3% !important;
}
.layout-main {
    padding: 10% 0% 0% 9% !important;
}
}
@media (max-width: 890px){
    .anchonamen{
        width: 228px !important;
    }
    .bnn {
        top: -5%;
        right: 11% !important;
    }
    .collapsed, .bntt , .form-inline{
        display: none !important;
    }
    .descargarexcel {
    right: 20% !important;
}
.cuandrologin{
    margin-top: -1%;
    margin-left: 33%;
}
#celular{
    display: none;
}
.colimg{
    display: none;
}
/* .logo {
    margin-top: 1% !important;
    width: 22%;
    margin-left: 3%;
} */
}
@media (max-width: 769px){

    .anchonamen{
        width: 228px !important;
    }
    .bnn {
        top: -5%;
        right: 13% !important;
    }
    .collapsed, .bntt , .form-inline{
        display: none !important;
    }
    .layout-main {
    padding: 10% 0% 0% 9% !important;
}
}
</style>